var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-content"},[_vm._v(" SITE DOWN ")])
}
var staticRenderFns = []

export { render, staticRenderFns }